export const exportToJSON = (accounts, monthlyData) => {
  const exportData = {
    exportDate: new Date().toISOString(),
    version: "1.0",
    accounts: {
      assets: accounts.assets,
      debts: accounts.debts
    },
    monthlyData: monthlyData,
    summary: {
      totalMonths: monthlyData.length,
      dateRange: monthlyData.length > 0 ? {
        earliest: monthlyData[0].month,
        latest: monthlyData[monthlyData.length - 1].month
      } : null,
      currentNetWorth: monthlyData.length > 0
        ? monthlyData[monthlyData.length - 1].netWorth
        : 0
    }
  };

  const jsonString = JSON.stringify(exportData, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  const timestamp = new Date().toISOString().split('T')[0];
  link.href = url;
  link.download = `wealth-tracker-export-${timestamp}.json`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
